import * as React from "react";
import Paper from "@material-ui/core/Paper";
import {AppState} from "../../store";
import {connect} from "react-redux";
import { UserState, User } from "../../store/user/types";

interface IProps {
    t: any;
    user: UserState;
}

interface IHeaderState {
    user : User;
}

class Welcome extends React.Component<IProps,IHeaderState>{

    state = {
        user: this.props.user.user ? this.props.user.user : {login:''}
    }

    componentDidMount(): void {
        document.title = this.props.t('welcome.doctitle')
    }

    render (){
        return(
            <div>
                <h3> { this.props.t('welcome.title') } </h3>
                <Paper style={{padding: "10px", margin: "25px"}}>
                        <strong> { this.props.t('welcome.header') } </strong>
                    <table style={{margin: '10px'}}>
                        <tbody>
                            <tr>
                                <td><strong>{ this.props.t('welcome.firstName')}</strong></td>
                                <td>{this.state.user.firstName}</td>
                            </tr>
                            <tr>
                                <td><strong>{ this.props.t('welcome.lastName')}</strong></td>
                                <td>{this.state.user.lastName}</td>
                            </tr>
                            <tr>
                                <td><strong>{ this.props.t('welcome.email')}</strong></td>
                                <td>{this.state.user.email}</td>
                            </tr>
                        </tbody>                    
                    </table>
                    { this.props.t('welcome.info')}
                </Paper>
            </div>
        );
    }
}

const mapStateToProps = (state: AppState) => ({
    user: state.user
});

export default connect(mapStateToProps)(Welcome);